// Important: this file is generated from the 'build' script and should not be
// edited directly
export var version = '3.16.2';
//# sourceMappingURL=version.js.map